import { VehicleModelWithInsurancesForD2CDto } from '@orcar/common';
import { CAR_FUEL, MAX_YEAR } from '@orcar/common-d2c';
import { INSURANCE_BUTTONS } from '@/constants/insurance';
import { CAR_TYPE } from '@/constants/vehicle-model';
import { getMaxFinalPrice } from './vehicle-model';

export const getDefaultFilterOptions = (
  vehicleModelList: VehicleModelWithInsurancesForD2CDto[] | undefined,
) => {
  const defaultMaxPrice = getMaxFinalPrice(vehicleModelList);

  const defaultFilterOptions = {
    minPrice: 0,
    maxPrice: defaultMaxPrice,
    minYear: MAX_YEAR - 11,
    maxYear: MAX_YEAR,
    carFuelList: CAR_FUEL.map((item) => item.id),
    carTypeList: CAR_TYPE.map((item) => item.id),
    optionList: [],
    insuranceList: INSURANCE_BUTTONS.map((item) => item.id),
  };

  return defaultFilterOptions;
};
